import Vue from 'vue'
import Vuex from 'vuex'
import util from '@/util/util'

Vue.use(Vuex)

const state = {
  USER_INFO: {
    realName: '',
    username: '',
    userId: null
  }, // 用户名
  CURRENT_PATIENT_NAME: null, // 当前患者名称
  SEARCH_PARAMS: null, // 查询参数
  HAS_INPUT_PASSWORD_ERROR: false // 密码是否输入错误
}

const mutations = {
  setValue: function (state, payload) {
    if (payload.category === 'user_info') {
      state.USER_INFO = payload.user_info
      util.setSessionInfo('user_info', payload.user_info)
    } else if (payload.category === 'search_params') {
      state.SEARCH_PARAMS = payload.search_params
      util.setSessionInfo('search_params', payload.search_params)
    } else if (payload.category === 'current_patient_name') {
      state.CURRENT_PATIENT_NAME = payload.current_patient_name
      util.setSessionInfo('current_patient_name', payload.current_patient_name)
    } else if (payload.category === 'has_input_password_error') {
      state.HAS_INPUT_PASSWORD_ERROR = payload.has_input_password_error
      util.setSessionInfo('has_input_password_error', payload.has_input_password_error)
    }
  }
}

const getters = {
  getValue: function (state) {
    return function (category) {
      if (category === 'user_info') {
        let localData = util.getSessionInfo('user_info')
        if (localData && state.USER_INFO.userId === null) {
          mutations.setValue(state, {
            category: 'user_info',
            user_info: localData
          })
        }
        return state.USER_INFO
      } else if (category === 'search_params') {
        let localData = util.getSessionInfo('search_params')
        if (localData && state.SEARCH_PARAMS === null) {
          mutations.setValue(state, {
            category: 'search_params',
            search_params: localData
          })
        }
        return state.SEARCH_PARAMS
      } else if (category === 'current_patient_name') {
        let localData = util.getSessionInfo('current_patient_name')
        if (localData && state.CURRENT_PATIENT_NAME === null) {
          mutations.setValue(state, {
            category: 'current_patient_name',
            current_patient_name: localData
          })
        }
        return state.CURRENT_PATIENT_NAME
      } else if (category === 'has_input_password_error') {
        let localData = util.getSessionInfo('has_input_password_error')
        if (localData && state.PATIENT_ID === 0) {
          mutations.setValue(state, {
            category: 'has_input_password_error',
            has_input_password_error: localData
          })
        }
        return state.HAS_INPUT_PASSWORD_ERROR
      }
    }
  }
}

const store = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js